import React, { useState, useEffect } from 'react';
import { G, styles, api } from '../theme.js';
import { Btn, Badge } from '../ui.jsx';

export function TrainingWidget({ go }) {
  const [open, setOpen] = useState(false);
  const [training, setTraining] = useState(null);
  const [completed, setCompleted] = useState(() => {
    try { return JSON.parse(localStorage.getItem('tradeops-training-done') || '[]'); }
    catch { return []; }
  });

  useEffect(() => { if (open && !training) api('/api/help/training').then(setTraining).catch(()=>{}); }, [open]);

  const markDone = id => {
    const next = Array.from(new Set([...completed, id]));
    setCompleted(next);
    try { localStorage.setItem('tradeops-training-done', JSON.stringify(next)); } catch {}
  };
  const reset = () => { setCompleted([]); try { localStorage.removeItem('tradeops-training-done'); } catch {} };

  const totalLessons = training?.modules.reduce((s,m)=>s+m.lessons.length, 0) || 0;
  const pct = totalLessons > 0 ? Math.round(completed.length / totalLessons * 100) : 0;

  if (!open) {
    return <div onClick={()=>setOpen(true)} style={{
      position:'fixed', bottom:20, left:20, zIndex:9000,
      padding:'10px 16px', borderRadius:30,
      background: G.card, border:`1px solid ${G.cyan+'66'}`,
      color: G.cyan, display:'flex', alignItems:'center', gap:8,
      cursor:'pointer', fontSize:13, fontWeight:600,
      boxShadow:'0 4px 14px rgba(0,0,0,.3)',
    }} title="Training Guide">
      <span style={{ fontSize:18 }}>🎓</span>
      <span>Training {pct>0?`(${pct}%)`:''}</span>
    </div>;
  }

  return <div style={{
    position:'fixed', bottom:20, left:20, zIndex:9000,
    width:380, maxHeight:'72vh', display:'flex', flexDirection:'column',
    background:G.card, border:`1px solid ${G.cardBorder}`, borderRadius:14,
    boxShadow:'0 10px 40px rgba(0,0,0,.45)',
  }}>
    <div style={{
      padding:'12px 16px', borderBottom:`1px solid ${G.border}`,
      background:`linear-gradient(135deg,${G.cyanLight},transparent)`,
      borderRadius:'14px 14px 0 0',
      display:'flex', alignItems:'center', justifyContent:'space-between',
    }}>
      <div>
        <div style={{ display:'flex', alignItems:'center', gap:8 }}>
          <span style={{ fontSize:18 }}>🎓</span>
          <strong style={{ fontSize:14 }}>Training Guide</strong>
          {pct === 100 && <Badge c={G.green} bg={G.greenLight}>Done!</Badge>}
        </div>
        <div style={{ height:4, background:G.input, borderRadius:2, marginTop:8, width:200, overflow:'hidden' }}>
          <div style={{ height:'100%', width:`${pct}%`, background: G.cyan, transition:'width .3s' }}/>
        </div>
      </div>
      <span onClick={()=>setOpen(false)} style={{ cursor:'pointer', color:G.textMuted, fontSize:18 }}>×</span>
    </div>

    <div style={{ flex:1, overflow:'auto', padding:12 }}>
      {!training ? <div style={{ padding:20, textAlign:'center', color:G.textMuted, fontSize:13 }}>Loading...</div>
      : training.modules.map(m => (
        <div key={m.id} style={{ marginBottom:14 }}>
          <div style={{ fontSize:12, fontWeight:700, color:G.textMuted, textTransform:'uppercase', letterSpacing:'.05em', marginBottom:6, padding:'0 4px' }}>{m.title}</div>
          {m.lessons.map(l => {
            const done = completed.includes(l.id);
            return <div key={l.id} style={{
              display:'flex', alignItems:'center', gap:8,
              padding:'8px 10px', borderRadius:8, marginBottom:3,
              cursor:'pointer',
              background: done ? G.greenLight : 'transparent',
              border: `1px solid ${done ? G.green+'44' : 'transparent'}`,
            }}
              onClick={()=>{ if (l.goTo) { go(l.goTo); setOpen(false); } markDone(l.id); }}>
              <span style={{ fontSize:16 }}>{done?'✅':'○'}</span>
              <div style={{ flex:1, minWidth:0 }}>
                <div style={{ fontSize:13, fontWeight:600 }}>{l.title}</div>
                <div style={{ fontSize:11, color:G.textMuted }}>{l.duration} {l.goTo ? `· → ${l.goTo}` : ''}</div>
              </div>
            </div>;
          })}
        </div>
      ))}
    </div>

    <div style={{ padding:10, borderTop:`1px solid ${G.border}`, display:'flex', justifyContent:'space-between', alignItems:'center' }}>
      <span style={{ fontSize:11, color:G.textMuted }}>{completed.length} of {totalLessons} lessons done</span>
      <Btn sz="xs" onClick={reset}>Reset</Btn>
    </div>
  </div>;
}
